import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const logout = async (token: string) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(`${API_URL}/logout`, {}, config);
  return response.data;
};
export default logout;
